export default "__VITE_ASSET__m_39senr__"